// extracted by mini-css-extract-plugin
export var label = "_g6-0";
export var treatmentCard = "_g6-1";